import Box, { BoxProps } from '@liquidweb-dev/undercurrent/Box';
import ArrowUpRightIcon from '@liquidweb-dev/undercurrent/icons/lucide/ArrowUpRight';
import ClipboardListIcon from '@liquidweb-dev/undercurrent/icons/lucide/ClipboardList';
import GlobeLockIcon from '@liquidweb-dev/undercurrent/icons/lucide/GlobeLock';
import HistoryIcon from '@liquidweb-dev/undercurrent/icons/lucide/History';
import KeyIcon from '@liquidweb-dev/undercurrent/icons/lucide/KeyRound';
import ListIcon from '@liquidweb-dev/undercurrent/icons/lucide/List';
import Settings2Icon from '@liquidweb-dev/undercurrent/icons/lucide/Settings2';
import SquareAsteriskIcon from '@liquidweb-dev/undercurrent/icons/lucide/SquareChartGantt';
import UsersIcon from '@liquidweb-dev/undercurrent/icons/lucide/Users';
import ReceiptIcon from '@liquidweb-dev/undercurrent/icons/lucide/Receipt';
import WalletCardsIcon from '@liquidweb-dev/undercurrent/icons/lucide/WalletCards';
import ListChecksIcon from '@liquidweb-dev/undercurrent/icons/lucide/ListChecks';
import UCListSubheader, {
	ListSubheaderProps,
} from '@liquidweb-dev/undercurrent/ListSubheader';
import MenuItem from '@liquidweb-dev/undercurrent/MenuItem';
import TextField, {
	TextFieldProps,
} from '@liquidweb-dev/undercurrent/TextField';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';
import { selectors as appConfigSelectors } from 'modules/appConfig';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import paths from './paths';

const ListSubheader = ({ sx, ...rest }: ListSubheaderProps) => (
	<UCListSubheader
		sx={combineSx(
			{
				paddingY: 50,
				paddingX: 150,
				textTransform: 'uppercase',
				background: 'transparent',
				color: ({ vars }) => vars.palette.uc.text.weak,
				typography: 'label-sm',
			},
			sx,
		)}
		{...rest}
	/>
);

const MenuItemWrapper = ({ sx, ...rest }: BoxProps) => (
	<Box
		sx={combineSx(
			{
				display: 'flex',
				gap: 100,
				alignItems: 'center',
			},
			sx,
		)}
		{...rest}
	/>
);

const SmallNav = (props: TextFieldProps) => {
	const { pathname } = useLocation();
	const history = useHistory();
	const userProfilePath = useSelector(appConfigSelectors.getUserProfilePath);

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;

		if (value === 'profile') {
			window.open(userProfilePath, '_blank');
		} else {
			history.push(value);
		}
	};
	return (
		<TextField
			select
			onChange={handleChange}
			value={pathname}
			fullWidth
			{...props}
		>
			<ListSubheader>General</ListSubheader>
			<MenuItem value={paths.accountDetails}>
				<MenuItemWrapper>
					<ListIcon />
					<span>Details</span>
				</MenuItemWrapper>
			</MenuItem>
			<MenuItem value={paths.accountPreferences}>
				<MenuItemWrapper>
					<Settings2Icon />
					<span>Preferences</span>
				</MenuItemWrapper>
			</MenuItem>
			<MenuItem value="profile">
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						gap: 100,
						width: '100%',
					}}
				>
					<MenuItemWrapper>
						<UsersIcon />
						<span>Profile</span>
					</MenuItemWrapper>
					<ArrowUpRightIcon />
				</Box>
			</MenuItem>
			<MenuItem value={paths.accountUsers}>
				<MenuItemWrapper>
					<UsersIcon />
					<span>Users</span>
				</MenuItemWrapper>
			</MenuItem>
			<MenuItem value={paths.accountActivity}>
				<MenuItemWrapper>
					<HistoryIcon />
					<span>Activity</span>
				</MenuItemWrapper>
			</MenuItem>
			<MenuItem value={paths.accountAllServices}>
				<MenuItemWrapper>
					<ClipboardListIcon />
					<span>All Services</span>
				</MenuItemWrapper>
			</MenuItem>

			<ListSubheader>Billing</ListSubheader>
			<MenuItem value={paths.billingOverview}>
				<MenuItemWrapper>
					<WalletCardsIcon />
					<span>Overview</span>
				</MenuItemWrapper>
			</MenuItem>
			<MenuItem value={paths.billingTransactions}>
				<MenuItemWrapper>
					<ReceiptIcon />
					<span>Transactions</span>
				</MenuItemWrapper>
			</MenuItem>

			<ListSubheader>Security</ListSubheader>
			<MenuItem value={paths.apiTokens}>
				<MenuItemWrapper>
					<SquareAsteriskIcon />
					<span>API tokens</span>
				</MenuItemWrapper>
			</MenuItem>
			<MenuItem value={paths.cloudVpn}>
				<MenuItemWrapper>
					<GlobeLockIcon />
					<span>Cloud VPN</span>
				</MenuItemWrapper>
			</MenuItem>
			<MenuItem value={paths.sshKeys}>
				<MenuItemWrapper>
					<KeyIcon />
					<span>SSH Keys</span>
				</MenuItemWrapper>
			</MenuItem>
			<MenuItem value={paths.compliance}>
				<MenuItemWrapper>
					<ListChecksIcon />
					<span>Compliance</span>
				</MenuItemWrapper>
			</MenuItem>
		</TextField>
	);
};

export default SmallNav;
